import { createContext } from 'react';

export const { Provider, Consumer } = createContext();

export default {
  Provider,
  Consumer,
};



// WEBPACK FOOTER //
// ./src/compositions/Reports/ReportConfigBuilder/Context.js